import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {ph} from "@pg-design/helpers-css-strings";
import {Text} from "@pg-design/text-module";

import {IBoosterSegments} from "../../types/IBoosterSegments";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";

interface IBoosterTextProps {
    text?: IBoosterSegments;
    className?: string;
}

export const BoosterText = (props: IBoosterTextProps) => {
    const {text, className} = props;

    if (!text || text.length === 0) {
        return null;
    }

    return (
        <Text as="div" variant="headline_6" className={className} css={textStyle}>
            {text.map((segment, index) => {
                const separator = index > 0 ? " " : "";

                if (typeof segment === "object") {
                    switch (segment.type) {
                        case IBoosterTextSegmentType.HIGHLIGHTED:
                            return (
                                <React.Fragment key={index}>
                                    {separator}
                                    <span key={index} css={highlightedTextStyle}>
                                        {segment.text}
                                    </span>
                                </React.Fragment>
                            );
                        case IBoosterTextSegmentType.BUTTON:
                            return (
                                <React.Fragment key={index}>
                                    {separator}
                                    <Button variant="none_secondary" css={ctaSegmentStyle}>
                                        {segment.text}
                                    </Button>
                                </React.Fragment>
                            );
                        default:
                            return null;
                    }
                }

                return (
                    <React.Fragment key={index}>
                        {separator}
                        {segment}
                    </React.Fragment>
                );
            })}
        </Text>
    );
};

const textStyle = css`
    color: #000;
    font-weight: 500;
`;

const highlightedTextStyle = css`
    background-color: var(--colors-primary);
    font-weight: 700;
`;

const ctaSegmentStyle = css`
    display: block;
    ${ph(0)};
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {ph} from "@pg-design/helpers-css-strings";
import {Text} from "@pg-design/text-module";

import {IBoosterSegments} from "../../types/IBoosterSegments";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";

interface IBoosterTextProps {
    text?: IBoosterSegments;
    className?: string;
}

export const BoosterText = (props: IBoosterTextProps) => {
    const {text, className} = props;

    if (!text || text.length === 0) {
        return null;
    }

    return (
        <Text as="div" variant="headline_6" className={className} css={textStyle}>
            {text.map((segment, index) => {
                const separator = index > 0 ? " " : "";

                if (typeof segment === "object") {
                    switch (segment.type) {
                        case IBoosterTextSegmentType.HIGHLIGHTED:
                            return (
                                <React.Fragment key={index}>
                                    {separator}
                                    <span key={index} css={highlightedTextStyle}>
                                        {segment.text}
                                    </span>
                                </React.Fragment>
                            );
                        case IBoosterTextSegmentType.BUTTON:
                            return (
                                <React.Fragment key={index}>
                                    {separator}
                                    <Button variant="none_secondary" css={ctaSegmentStyle}>
                                        {segment.text}
                                    </Button>
                                </React.Fragment>
                            );
                        default:
                            return null;
                    }
                }

                return (
                    <React.Fragment key={index}>
                        {separator}
                        {segment}
                    </React.Fragment>
                );
            })}
        </Text>
    );
};

const textStyle = css`
    color: #000;
    font-weight: 500;
`;

const highlightedTextStyle = css`
    background-color: var(--colors-primary);
    font-weight: 700;
`;

const ctaSegmentStyle = css`
    display: block;
    ${ph(0)};
`;
